import { ChatMessage } from '@/store/chatStore'
import { MessageBubble } from './MessageBubble'

interface MessageListProps {
  messages: ChatMessage[]
  onRetry: (messageId: string) => void
}

export function MessageList({ messages, onRetry }: MessageListProps) {
  return (
    <div className="space-y-message-gap">
      {messages.map((message, index) => {
        const prevMessage = messages[index - 1]
        const showAvatar =
          message.role !== 'user' &&
          (!prevMessage || prevMessage.role !== message.role)

        const showTimestamp =
          !messages[index + 1] ||
          messages[index + 1].role !== message.role ||
          new Date(messages[index + 1].timestamp).getTime() -
            new Date(message.timestamp).getTime() >
            60000 // More than 1 minute apart

        return (
          <MessageBubble
            key={message.id}
            message={message}
            showAvatar={showAvatar}
            showTimestamp={showTimestamp}
            onRetry={() => onRetry(message.id)}
          />
        )
      })}
    </div>
  )
}
